/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { PulseLoader } from 'react-spinners';
import Select from 'react-select';
import { FaAngleRight } from 'react-icons/fa';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { sendMessage } from '../../../queries';

import {
  Row,
  Label,
  Input,
  SelectLabel,
  Textarea,
  Button,
} from '../../../assets/styles';

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        { value: '001', label: 'Conta' },
        { value: '002', label: 'Materiais' },
        { value: '003', label: 'Pedidos' },
        { value: '004', label: 'Pagamentos' },
        { value: '005', label: 'Meu motivo não está aqui' },
      ],
      reason: '',
      phoneNumber: '',
      email: '',
      textarea: '',
    };
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      reason,
      phoneNumber,
      email,
      textarea,
      reasonError,
      emailError,
      phoneNumberError,
      textareaError,
    } = this.state;

    if (!reasonError && !emailError && !phoneNumberError && !textareaError) {
      this.setState({ loading: true });

      this.props
        .sendMessage({
          variables: {
            storeId: this.props.store.id,
            role: this.props.store.roleType,
            reason,
            name: this.props.user.name,
            phone: phoneNumber,
            email,
            message: textarea,
          },
        })
        .then(async () => {
          this.setState({
            loading: false,
            phoneNumber: '',
            email: '',
            textarea: '',
          });

          this.props.alert.success('Mensagem enviada com sucesso');
        });
    }
  }

  validateInputs = () => {
    const {
      reason,
      email,
      phoneNumber,
      textarea,
    } = this.state;

    this.setState({
      reasonError: false,
      emailError: false,
      phoneNumberError: false,
      textareaError: false,
    });

    if (reason.length === 0) this.setState({ reasonError: true });
    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });
    const phoneReg = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;
    if (!phoneReg.test(phoneNumber)) this.setState({ phoneNumberError: true });
    if (textarea.length === 0) this.setState({ textareaError: true });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSelectChange = (field, value) => {
    this.setState({ [field]: value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      options,
      phoneNumber,
      email,
      textarea,
      reasonError,
      phoneNumberFocus,
      phoneNumberError,
      emailFocus,
      emailError,
      textareaError,
      textareaFocus,
    } = this.state;

    if (phoneNumber.length > 14) this.phoneMask = '(99) 99999-9999';
    else if (phoneNumber.length < 15) this.phoneMask = '(99) 9999-99999';

    return (
      <Row>
        <div className="row-1">
          <Label>
            <p className="fieldName">Motivo</p>
            <SelectLabel error={reasonError}>
              <Select
                className="input"
                classNamePrefix="input"
                placeholder="Selecione"
                onChange={value => this.handleSelectChange('reason', value.label)}
                options={options}
                isSearchable={false}
                isClearable={false}
              />
            </SelectLabel>
          </Label>
        </div>
        <div className="row-2">
          <Label>
            <p className="fieldName">Telefone</p>
            <InputMask
              mask={this.phoneMask}
              maskChar={null}
              value={phoneNumber}
              onChange={this.handleInputChange}
              onKeyUp={this.handleInputChange}
              onFocusInput={phoneNumberFocus}
              onFocus={() => this.onFocus('phoneNumberFocus')}
              onBlur={() => this.onBlur('phoneNumberFocus')}
            >
              {inputProps => (
                <Input
                  {...inputProps}
                  type="tel"
                  name="phoneNumber"
                  error={phoneNumberError}
                />
              )}
            </InputMask>
          </Label>
          <Label>
            <p className="fieldName">E-mail</p>
            <Input
              type="email"
              name="email"
              value={email}
              error={emailError}
              onFocusInput={emailFocus}
              onChange={this.handleInputChange}
              onFocus={() => this.onFocus('emailFocus')}
              onBlur={() => this.onBlur('emailFocus')}
            />
          </Label>
        </div>
        <Label>
          <p className="fieldName">O que aconteceu?</p>
          <Textarea
            name="textarea"
            maxLength="300"
            value={textarea}
            error={textareaError}
            onFocusInput={textareaFocus}
            onChange={this.handleInputChange}
            onFocus={() => this.onFocus('textareaFocus')}
            onBlur={() => this.onBlur('textareaFocus')}
          />
        </Label>
        <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
          {!loading ? (
            <span>
              {'Enviar'}
              <FaAngleRight className="fa fa-angle-right" />
            </span>
          ) : (
            <PulseLoader
              sizeUnit="px"
              size={7}
              color="#FFFFFF"
              loading={loading}
              style={{ paddingLeft: '25px' }}
            />
          )}
        </Button>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  store: state.store,
});

export default compose(
  withAlert(),
  connect(mapStateToProps, null),
  graphql(sendMessage, { name: 'sendMessage' }),
)(Form);
